<template>
    <!-- Invite Employee Component (Branch, Department and SCM Product Permission needs to be Integrated) -->
    <div class="page-layout blank contacts-manage">
        <div class="pb-10">
            <h2 class="headerblock">
                <div class="breadcrumbnew">
                    <router-link to="/managecompany">List View</router-link>
                    <a style="cursor: pointer;" @click="goBackToEmployees">Employees</a>
                    <span>Invite</span>
                </div>
            </h2>
            <div class="page-layout carded left-sidebar" style="overflow-y: visible;">
                <div class="page-content-wrapper" style="border-radius: 15px;padding: 0px;">
                    <div class="page-content custom-scrollbar pt-4 pb-9 px-1"
                        style="border-radius: 15px;background-color: #ecf1f9 !important;">
                        <h5 class="page-content-header-text">INVITE NEW EMPLOYEE</h5>
                        <!-- <h5 class="page-content-header-text" v-else>INVITE NEW USER TO CRM</h5> -->
                        <form>
                            <input autocomplete="off" name="hidden" type="text" style="display:none;" />
                            <div class="pl-15 pr-15">
                                <div class="row">
                                    <div class="col-lg-6 mt-10">
                                        <div class="form-group">
                                            <input class="inputFieldNew" type="text" data-vv-scope="newEmployee"
                                                data-vv-as="First Name" name="first_name"
                                                :maxlength="maxlengthemployeefirstname" v-model="newEmployee.first_name"
                                                v-validate="'required'" placeholder="Enter First Name" />
                                            <span class="highlightInput"></span>
                                            <span class="inputBorder"></span>
                                            <label class="inputLabel fw-600">
                                                First Name
                                                <sup class="prefixIcon">*</sup>
                                            </label>
                                            <span
                                                class="character-count text-grey">{{maxlengthemployeefirstname - newEmployee.first_name.length}}/20</span>
                                            <span class="invalid-feedback-form text-danger"
                                                style="text-transform: none !important;"
                                                v-show="errors.has('newEmployee.first_name')">{{errors.first('newEmployee.first_name')}}</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 mt-10">
                                        <div class="form-group">
                                            <input class="inputFieldNew" type="text"
                                                :maxlength="maxlengthemployeemiddlename"
                                                v-model="newEmployee.middle_name" placeholder="Enter Middle Name" />
                                            <span class="highlightInput"></span>
                                            <span class="inputBorder"></span>
                                            <label class="inputLabel fw-600">Middle Name</label>
                                            <span
                                                class="character-count text-grey">{{maxlengthemployeemiddlename - newEmployee.middle_name.length}}/20</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-6 mt-10">
                                        <div class="form-group">
                                            <input class="inputFieldNew" type="text" name="last_name"
                                                data-vv-scope="newEmployee" data-vv-as="Last Name"
                                                :maxlength="maxlengthemployeelastname" v-model="newEmployee.last_name"
                                                v-validate="'required'" autocomplete="new-password"
                                                placeholder="Enter Last Name" />
                                            <span class="highlightInput"></span>
                                            <span class="inputBorder"></span>
                                            <label class="inputLabel fw-600">
                                                Last Name
                                                <sup class="prefixIcon">*</sup>
                                            </label>
                                            <span
                                                class="character-count text-grey">{{maxlengthemployeelastname - newEmployee.last_name.length}}/20</span>
                                            <span class="invalid-feedback-form text-danger"
                                                style="text-transform: none !important;"
                                                v-show="errors.has('newEmployee.last_name')">{{errors.first('newEmployee.last_name')}}</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 mt-10 pt-4">
                                        <div class="form-check form-check-inline">
                                            <label class="form-label-radio text-secondary fw-600">
                                                Gender
                                                <sup class="ml-1 prefixIcon">*</sup>
                                            </label>
                                        </div>
                                        <div class="preview-elements previewElementsContacts radiooptions mt-2">
                                            <div class="form-check form-check-inline gender-radio" v-if="!customGender">
                                                <label class="form-check-label check-label-dc">
                                                    <input class="form-check-input" :disabled="UserExists"
                                                        data-vv-scope="newEmployee" data-vv-as="Gender"
                                                        v-validate="'required'" type="radio"
                                                        v-model="newEmployee.gender" name="gender"
                                                        :checked="newEmployee.gender=='Male'" selected value="Male" />
                                                    <span class="radio-icon"></span>
                                                    <span class="form-check-description fw-600">Male</span>
                                                </label>
                                            </div>
                                            <div class="form-check form-check-inline gender-radio" v-if="!customGender">
                                                <label class="form-check-label check-label-dc">
                                                    <input class="form-check-input" :disabled="UserExists"
                                                        data-vv-scope="newEmployee" data-vv-as="Gender"
                                                        v-validate="'required'" type="radio"
                                                        v-model="newEmployee.gender" name="gender"
                                                        :checked="newEmployee.gender=='Female'" value="Female" />
                                                    <span class="radio-icon"></span>
                                                    <span class="form-check-description fw-600">Female</span>
                                                </label>
                                            </div>
                                            <div class="form-check form-check-inline gender-radio">
                                                <label class="form-check-label check-label-dc">
                                                    <input class="form-check-input" :disabled="UserExists"
                                                        data-vv-scope="newEmployee" data-vv-as="Gender"
                                                        v-validate="'required'" type="radio" name="gender"
                                                        value="Others" :checked="customGender == true"
                                                        @change="customSelected" />
                                                    <span class="radio-icon"></span>
                                                    <span class="form-check-description fw-600 d-flex">
                                                        Custom
                                                        <div class="d-flex">
                                                            <input v-if="customGender" data-vv-scope="newEmployee"
                                                                data-vv-as="Gender" name="gender"
                                                                v-validate="'required'" type="text"
                                                                v-model="newEmployee.gender"
                                                                style="margin-left: 10px; border-bottom: 1px solid; background: transparent; padding-right: 15px;">
                                                            <span v-if="customGender" @click.prevent="customDeselected"
                                                                style="cursor: pointer; margin-left: -10px;">
                                                                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/cross.svg"
                                                                    height="8px">
                                                            </span>
                                                        </div>
                                                    </span>
                                                </label>
                                            </div>
                                            <span class="invalid-feedback-form text-danger"
                                                style="text-transform: none !important;"
                                                v-show="errors.has('newEmployee.gender')">{{errors.first('newEmployee.gender')}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-6 mt-10">
                                        <span class="text-secondary whiteSpace fs-14 fw-600">
                                            Business Email
                                            <sup class="prefixIcon">*</sup>
                                        </span>
                                        <div class="email input-group mt-2">
                                            <input type="text" class="form-control-email-dropdown" @blur="checkEmail"
                                                v-model="newEmployee.primary_email" placeholder="Enter Business Email"
                                                data-vv-scope="newEmployee" data-vv-as="Business Email" name="email_id"
                                                v-validate="{required:true,regex: /^[a-zA-Z0-9-_.]+$/}"
                                                autocomplete="new-password" />
                                            <span class="input-group-addon-email"
                                                style="border-bottom: 1px solid #a9aaad;margin-top: 2px;font-size: 20px;">@</span>
                                            <!-- <div
                        class="input-group-append-email"
                        style="margin-left: 0px !important;margin-top: 1px;"
                      > -->
                                            <multiselect ref="multiselectRef"
                                                class="emailselect-multiselect loaderdark no-default-icon down-arrow"
                                                v-model="selecteddomainname" :options="getDomain" name="select_domain"
                                                @open="getAllDomain" @search-change="getAllDomain" @close="checkEmail"
                                                v-validate="'required'" placeholder="Select Domain Name"
                                                data-vv-scope="newEmployee" :loading="isDomainName"
                                                data-vv-as="Domain Name" style="width: 220px;">
                                                <span slot="no-options">Please add Domain Name</span>
                                            </multiselect>
                                            <!-- </div> -->
                                        </div>
                                        <span class="invalid-feedback-form text-danger" v-if="EmailExists">Business
                                            Email already
                                            Exists</span>
                                        <span class="invalid-feedback-form text-danger" v-if="!EmailValid">Please Enter
                                            Valid Email</span>
                                        <div class="d-flex">
                                            <span class="invalid-feedback-form text-danger"
                                                style="text-transform: none !important;"
                                                v-show="errors.has('newEmployee.email_id')">{{errors.first('newEmployee.email_id')}}</span>
                                            <span class="invalid-feedback-form text-danger"
                                                style="text-transform: none !important; margin-left:13.5rem"
                                                v-show="errors.has('newEmployee.select_domain')">{{errors.first('newEmployee.select_domain')}}</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 mt-10">
                                        <div class="form-check form-check-inline">
                                            <label class="form-label-radio text-secondary fw-600">
                                                User Access
                                                <sup class="ml-1 prefixIcon">*</sup>
                                            </label>
                                        </div>
                                        <div class="preview-elements previewElementsContacts radiooptions mt-3">
                                            <div class="form-check form-check-inline user-perm">
                                                <label class="form-check-label check-label-dc"
                                                    style="width: 80px !important;">
                                                    <input class="form-check-input" type="radio" v-bind:value="true"
                                                        v-model="newEmployee.is_admin" data-vv-scope="newEmployee"
                                                        @click="onToggleAdmin()" data-vv-as="User Access"
                                                        name="useraccess" />
                                                    <span class="radio-icon"></span>
                                                    <span class="form-check-description fw-600">Admin</span>
                                                </label>
                                            </div>
                                            <div class="form-check form-check-inline user-perm">
                                                <label class="form-check-label check-label-dc">
                                                    <input class="form-check-input" type="radio" v-bind:value="true"
                                                        v-model="newEmployee.is_superadmin" data-vv-scope="newEmployee"
                                                        @click="onToggleIsAdmin()" data-vv-as="User Access"
                                                        name="useraccess" />
                                                    <span class="radio-icon"></span>
                                                    <span class="form-check-description fw-600">Super Admin</span>
                                                </label>
                                            </div>
                                            <div class="form-check form-check-inline user-perm">
                                                <label class="form-check-label check-label-dc">
                                                    <input class="form-check-input" type="radio" v-bind:value="true"
                                                        v-model="is_user" data-vv-scope="newEmployee"
                                                        @click="onToggleUser()" data-vv-as="User Access"
                                                        name="useraccess" />
                                                    <span class="radio-icon"></span>
                                                    <span class="form-check-description fw-600">User</span>
                                                </label>
                                            </div>
                                            <!-- <span class="invalid-feedback-form text-danger" v-show="errors.has('newEmployee.useraccess')">{{errors.first('newEmployee.useraccess')}}</span> -->
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <!-- <div class="col-lg-6 mt-10">
                    <div class="form-group">
                      <input
                        class="inputFieldNew"
                        name="primary_email"
                        :disabled="UserExists"
                        data-vv-scope="newEmployee"
                        data-vv-as="Personal Email"
                        v-model="newEmployee.primary_email"
                        v-on:blur="checkPrimaryEmail"
                        v-validate="{required:true,regex: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,50})+$/}"
                        :maxlength="maxlengthemployeeprimaryemail"
                        type="text"
                        placeholder="Enter Email"
                      />
                      <span class="highlightInput"></span>
                      <span class="inputBorder"></span>
                      <label class="inputLabel fw-600" style="top: -1px !important;">
                        Personal Email
                        <sup class="prefixIcon">*</sup>
                      </label>
                      <span
                        class="character-count text-grey"
                      >{{maxlengthemployeeprimaryemail - newEmployee.primary_email.length}}/230</span>
                      <span
                        class="invalid-feedback-form text-danger"
                        v-if="primaryEmailExists"
                      >Personal Email Already Exists!!</span>
                      <span
                        class="invalid-feedback-form text-danger"
                        v-if="!primaryEmailValid"
                      >Please Enter Valid Personal Email</span>
                      <span
                        class="invalid-feedback-form text-danger"
                        style="text-transform: none !important;"
                        v-show="errors.has('newEmployee.primary_email')"
                      >{{errors.first("newEmployee.primary_email")}}</span>
                    </div>
                  </div> -->
                                    <div class="col-lg-6 mt-10">
                                        <div class="form-group">
                                            <input v-if="!showPassword" class="inputFieldNew" type="password"
                                                data-vv-scope="newEmployee" name="password"
                                                v-validate="{required:true,min:8,regex:/^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=]).*$/}"
                                                v-model="newEmployee.password" placeholder="Enter Password"
                                                autocomplete="new-password" oncopy="return false" onpaste="return false"
                                                oncut="return false" />
                                            <input v-else class="inputFieldNew" type="text" data-vv-scope="newEmployee"
                                                name="password"
                                                v-validate="{required:true,min:8,regex:/^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=]).*$/}"
                                                v-model="newEmployee.password" placeholder="Enter Password"
                                                autocomplete="new-password" oncopy="return false" onpaste="return false"
                                                oncut="return false" />
                                            <span v-if="!showPassword"
                                                style="position: absolute; right: 6px; top: 43px;"
                                                @click="showPassword = !showPassword">
                                                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/hide-password.svg"
                                                    alt="eye" style="width: 20px;">
                                            </span>
                                            <span v-else style="position: absolute; right: 6px; top: 43px;"
                                                @click="showPassword = !showPassword">
                                                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/show-password.svg"
                                                    alt="eye" style="width: 20px;">
                                            </span>
                                            <span class="inputBorder"></span>
                                            <label class="inputLabel fs-14 fw-600">
                                                Password
                                                <sup class="prefixIcon">*</sup>
                                            </label>
                                            <span class="invalid-feedback-form text-danger"
                                                v-show="errors.has('newEmployee.password')">{{errors.first('newEmployee.password')}}</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 mt-10">
                                        <span class="text-secondary whiteSpace fs-14 fw-600">
                                            Phone Number
                                            <sup class="prefixIcon">*</sup>
                                        </span>
                                        <vue-tel-input class="teleContactborderedDark mt-4" id="add_phone_number"
                                            data-vv-scope="newEmployee" data-vv-as="Phone Number" name="phone_number"
                                            v-model="newEmployee.primary_phone.phone_number"
                                            v-on:country-changed="countryChanged($event, 'employee_phone', 0)"
                                            ref="telInput" placeholder="Enter Phone Number" :disabledFormatting="false"
                                            :valid-characters-only="true" v-validate="{required:true,min:15}"
                                            :maxLen="maxPhoneLength" autocomplete="off"></vue-tel-input>
                                        <span class="invalid-feedback-form text-danger"
                                            style="text-transform: none !important;"
                                            v-show="errors.has('newEmployee.phone_number')">{{errors.first("newEmployee.phone_number")}}</span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-12 mt-10">
                                        <div class="pt-2">
                                            <span class="text-secondary whiteSpace vselectLabel fs-14 fw-600">
                                                Branch Name
                                                <sup class="prefixIcon">*</sup>
                                            </span>
                                            <multiselect
                                                class="diginew-multiselect comanyTimeSelect loaderdark no-default-icon down-arrow"
                                                placeholder="Select Branch Name" :clearable="false" :filterable="true"
                                                :options="branch_name" v-model="branch.name" @open="getBranches"
                                                @close="showDepartments" style="width: 100%;margin-top: 7px;"
                                                v-validate="'required'" data-vv-as="Branch Name" name="branchName"
                                                :multiple="false" :loading="isBranch" label="name"
                                                data-vv-scope="newEmployee"></multiselect>
                                            <span class="inputBorder"></span>
                                            <span class="invalid-feedback-form text-danger"
                                                style="text-transform: none !important;"
                                                v-show="errors.has('newEmployee.branchName')">Branch Name is
                                                Required</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12 mt-10">
                                        <div class="pt-2">
                                            <span class="text-secondary whiteSpace vselectLabel fs-14 fw-600">Department
                                                <sup class="prefixIcon">*</sup></span>
                                            <multiselect
                                                class="diginew-multiselect comanyTimeSelect loaderdark no-default-icon down-arrow"
                                                placeholder="Select Department" :clearable="false" :filterable="true"
                                                :options="branch_departments" v-model="department_name"
                                                style="width: 100%;margin-top: 7px;" v-validate="'required'"
                                                data-vv-as="Departments" name="branchDepartment" :multiple="false"
                                                :loading="isDept" data-vv-scope="newEmployee"></multiselect>
                                            <span class="invalid-feedback-form text-danger"
                                                style="text-transform: none !important;"
                                                v-show="errors.has('newEmployee.branchDepartment')">Branch Name is
                                                Required</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-12 mt-10">
                                        <div class="pt-2">
                                            <span class="text-secondary whiteSpace vselectLabel fs-14 fw-600">
                                                Reporting Manager
                                            </span>
                                            <multiselect
                                                class="diginew-multiselect comanyTimeSelect loaderdark loaderdark no-default-icon down-arrow"
                                                placeholder="Select Reporting Manager" :clearable="false"
                                                :filterable="true" :options="reporting_managers"
                                                v-model="newEmployee.reporting_manager" @open="getReportingManager"
                                                style="width: 100%;margin-top: 7px;" data-vv-as="Reporting Manager"
                                                name="reportingManager" :multiple="false" label="full_name"
                                                :loading="isReport" data-vv-scope="reportingManager"></multiselect>
                                            <span class="inputBorder"></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-10">
                                    <div class="col-lg-12">
                                        <div class="heading-title">Set Products Permissions</div>
                                        <table id="table-app-access" class="table table-striped">
                                            <thead>
                                                <tr>
                                                    <th style="width: 30%;">Product</th>
                                                    <th style="width: 30%;">Admin Access</th>
                                                    <th style="width: 40%;">Permission</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(product, index) in products" :key="index">
                                                    <td style="width: 30%;">{{product.product_name}}</td>
                                                    <td style="width: 30%;">
                                                        <span class="switch switch-lg mr-2" style="top: 4px;">
                                                            <input type="checkbox" :id="'productuid'+index.toString()"
                                                                :clicked="product.has_access"
                                                                @click="toggleAccess(product._id)" class="switch" />
                                                            <label :for="'productuid'+index.toString()"></label>
                                                        </span>
                                                    </td>
                                                    <td style="width: 40%;">
                                                        <!-- <span v-for="(item, productIndex) in userProducts" :key="productIndex">
                              <span v-if="item.product == product._id">
                                <input
                                  type="radio"
                                  class="radiobutton"
                                  :id="'read'+index.toString()"
                                  v-model="item.access_level"
                                  :name="'productuid'+index.toString()"
                                  @click="productPermission(product._id,index)"
                                  value="2"
                                />
                                <label :for="'read'+index.toString()" class="label-permissions">Read</label>

                                <input
                                  type="radio"
                                  class="radiobutton"
                                  :id="'write'+index.toString()"
                                  v-model="item.access_level"
                                  :name="'productuid'+index.toString()"
                                  @click="productPermission(product._id,index)"
                                  value="1"
                                />
                                <label
                                  :for="'write'+index.toString()"
                                  class="label-permissions"
                                >Write</label>

                                <input
                                  type="radio"
                                  class="radiobutton"
                                  :id="'admin'+index.toString()"
                                  v-model="item.access_level"
                                  :name="'productuid'+index.toString()"
                                  @click="productPermission(product._id,index)"
                                  value="0"
                                />
                                <label
                                  :for="'admin'+index.toString()"
                                  class="label-permissions"
                                >Admin</label>
                              </span>
                            </span>-->
                                                        <multiselect v-if="allowPermission.includes(product._id)"
                                                            class="digi-multiselect loaderbg" :max-height="200"
                                                            :searchable="true" :multiple="false" :taggable="false"
                                                            :close-on-select="true" :show-labels="false"
                                                            :clear-on-select="false" :hide-selected="true"
                                                            @open="getPermissions(product)"
                                                            placeholder="Select Permission"
                                                            :options="userProductsOptions"
                                                            v-model="userProductsPermission[index]"
                                                            @close="pushUserProductsPermissions(product,index)"
                                                            style="width:90% !important">
                                                        </multiselect>
                                                    </td>
                                                </tr>
                                                <!-- <tr v-for="(product,index) in products" :key="product.productuid">
                                                    <td style="width: 30%;">{{product.product_name}}</td>
                                                    <td style="width: 30%;">
                                                        <span class="switch switch-lg mr-2" style="top: 4px;">
                                                            <input type="checkbox" :id="'productuid'+index.toString()" v-on:change="select_product('productuid'+index.toString(),index)" :checked="selected_products.indexOf('productuid'+index.toString())>-1? 'checked': ''" class="switch">
                                                            <label :for="'productuid'+index.toString()"></label>
                                                        </span>
                                                    </td>
                                                    <td style="width: 40%;">
                                                        <span v-if="selected_products.indexOf('productuid'+index.toString())>-1">
                                                            <input type="radio" class="radiobutton" :id="'read'.concat(index)"  :name="product._id" v-model="permission_dict['productuid'+index.toString()]" value="2"><label :for="'read'.concat(index)"  class="label-permissions">Read</label>
                                                            <input type="radio" class="radiobutton" :id="'write'.concat(index)" :name="product._id" v-model="permission_dict['productuid'+index.toString()]" value="1"><label :for="'write'.concat(index)" value="write" class="label-permissions">Write</label>
                                                            <input type="radio" class="radiobutton" :id="'admin'.concat(index)" :name="product._id" v-model="permission_dict['productuid'+index.toString()]" value="0"><label :for="'admin'.concat(index)" value="admin" class="label-permissions">Admin</label>
                                                        </span>
                                                    </td>
                        </tr>-->
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </form>
                        <div class="d-flex justify-content-center align-items-center mt-5">
                            <a class="btn btn-white btn-smm btn-no-border-blue ml-3"
                                style="color:#fff !important;background-color: #e82828; box-shadow: none !important;min-width: 5rem;"
                                @click="$router.go(-1)">
                                CANCEL
                            </a>
                            <a class="btn btn-white btn-smm btn-no-border-blue ml-3"
                                style="color:#000 !important;background-color: #f29c1f; box-shadow: none !important;min-width: 5rem;"
                                @click="InviteEmployee">
                                INVITE
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {
        EventBus
    } from "./eventBus/nav-bar-event.js";
    import VueTelInput from "vue-tel-input";

    export default {
        data() {
            return {
                newEmployee: {
                    first_name: "",
                    middle_name: "",
                    last_name: "",
                    password: "",
                    primary_email: "",
                    primary_phone: {
                        phone_type: "",
                        phone_number: "",
                        country_code: "",
                        dial_code: "",
                    },
                    gender: "",
                    custom_gender: {
                        gender: "",
                        preposition: "",
                    },
                    email_id: "",
                    is_admin: false,
                    is_superadmin: false,
                    reporting_manager: {
                        _id: "",
                        full_name: "",
                    },
                },
                is_user: true,
                products: [],
                EmailExists: false,
                EmailValid: true,
                UserExists: false,
                permissions: [],
                userProducts: [],
                userProductsOptions: [],
                userProductsPermission: [],
                selected_products: [],
                permission_dict: {},
                maxPhoneLength: 15,
                maxlengthemployeefirstname: 20,
                maxlengthemployeemiddlename: 20,
                maxlengthemployeelastname: 20,
                maxlengthemployeeprimaryemail: 230,
                getDomain: [],
                selecteddomainname: "",
                primaryEmailExists: false,
                primaryEmailValid: true,
                country: null,
                branch: {},
                branch_name: [],
                department_name: "",
                allowPermission: [],
                branch_departments: [],
                allow_public_domain: false,
                showPassword: false,
                customGender: false,
                reporting_managers: [],
                isDomainName: false,
                isDept: false,
                isBranch: false,
                isReport: false
            };
        },
        props: {
            userData: {},
        },
        created() {
            this.getUserData();
            this.getProducts();
            this.checkPublicDomain();
            const dict = {
                custom: {
                    first_name: {
                        required: () => "First Name is Required",
                    },
                    last_name: {
                        required: () => "Last Name is Required",
                    },
                    primary_email: {
                        required: () => "Personal Email is Required",
                        regex: () => "Please Enter Valid Email",
                    },
                    select_domain: {
                        required: () => "Domain Selection is Required",
                    },
                    email_id: {
                        required: () => "Business Email is Required",
                        regex: () => "Please Enter Valid Name",
                    },
                    phone_number: {
                        required: () => "Phone Number is Required",
                        min: () => "Phone Number must Contain more than 9 Numbers",
                        regex: () => "Phone Number must Contain Valid Format",
                    },
                    gender: {
                        required: () => "Gender is Required",
                    },
                    preposition: {
                        required: () => "Please Select Type",
                    },
                    password: {
                        required: () => "Password is Required",
                        min: () => "Password must contain more than 8 characters",
                        regex: () => "Password must contain a valid format",
                    }
                },
            };
            this.$validator.localize("en", dict);
        },
        mounted() {
            this.$refs.multiselectRef.$refs.search.setAttribute("autocomplete", "new-password")
        },
        computed: {
            account() {
                return this.$store.getters.account;
            },
            loggedInUser() {
                return this.$store.getters.loggedInUser;
            },
            selectedCompany() {
                return this.$store.getters.selectedCompany;
            },
        },
        components: {
            VueTelInput,
        },
        methods: {
            // Sending Dial Code and Country Code
            countryChanged(country, variable, index) {
                switch (variable) {
                    case "employee_phone":
                        this.newEmployee.primary_phone.dial_code = country.dialCode;
                        this.newEmployee.primary_phone.country_code = country.iso2;
                        break;
                }
            },
            onToggleIsAdmin() {
                this.newEmployee.is_superadmin = true;
                this.newEmployee.is_admin = false;
                this.is_user = false;
            },
            onToggleAdmin() {
                this.newEmployee.is_admin = true;
                this.newEmployee.is_superadmin = false;
                this.is_user = false;
            },
            onToggleUser() {
                this.newEmployee.is_admin = false;
                this.newEmployee.is_superadmin = false;
                this.is_user = true;
            },

            // Getting Domains
            getAllDomain(key) {
                this.isDomainName = true
                this.$http
                    .get("/employees/get_company_domains")
                    .then(response => {
                        if (response.data.status_id == 1) {
                            this.getDomain = response.data.response;
                            if (this.allow_public_domain) {
                                this.getPublicDomain(key);
                            }
                            this.isDomainName = false
                        }
                    })
                    .catch(error => {});
            },

            // Getting Public Domains
            async getPublicDomain(key) {
                let params = {
                    search_key: "",
                    skip: 0,
                    limit: 10
                };
                if (key) {
                    params.search_key = key;
                }
                if (params.search_key) {
                    this.getDomain = [];
                }
                let res = await this.$http.post("/search_domain", params);
                if (res.data.status_id == 1) {
                    res.data.response.forEach(x => {
                        this.getDomain.push(x);
                    });
                }
            },

            // Getting Employee Data and Autofilled based on Employee Selection
            getUserData() {
                if (this.$route.params.id) {
                    this.UserExists = true;
                    this.$http
                        .post("/users/get_user_data", {
                            user_id: this.$route.params.id
                        })
                        .then(response => {
                            if (response.data.status_id == 1) {
                                this.newEmployee = response.data.response;
                                this.newEmployee.email_id = "";
                            }
                        })
                        .catch(error => {});
                }
            },

            async getBranches() {
                this.isBranch = true
                let res = await this.$http.get("/branches/");
                if (res.data.status_id == 1) {
                    this.branch_name = res.data.result;
                    this.isBranch = false
                }
            },

            toggleAccess(id) {
                if (this.allowPermission.includes(id)) {
                    this.allowPermission = this.allowPermission.filter(e => {
                        if (e !== id) {
                            return e;
                        }
                    });
                } else {
                    this.allowPermission.push(id);
                }
            },

            // Getting Permissions
            getPermissions(product) {
                let params = {
                    search_key: "",
                    product_id: product._id,
                    skip: 0,
                    limit: 100,
                };
                this.$http.post("/digi_products/get_role", params).then(res => {
                    if (res.data.status_id == 1) {
                        this.userProductsOptions = [];
                        res.data.response.forEach(ele => {
                            this.userProductsOptions.push(ele.name);
                        });
                        this.permissions = res.data.response;
                    }
                });
            },

            pushUserProductsPermissions(product, index) {
                this.permissions.forEach(ele => {
                    if (
                        this.userProductsPermission[index].includes(ele.name) &&
                        !this.userProducts.includes({
                            has_access: true,
                            product: ele._id,
                            access_level: ele.value,
                        })
                    ) {
                        this.userProducts.push({
                            has_access: true,
                            product: product._id,
                            access_level: ele.value,
                        });
                    }
                });
            },

            // Product Permissions Starts Selecting by Product ID
            select_product(productuid, index) {
                var index = this.selected_products.indexOf(productuid);
                if (index > -1) {
                    this.selected_products.splice(index, 1);
                } else {
                    this.selected_products.push(productuid);
                    this.permission_dict["productuid" + index.toString()] = 2;
                }
            },

            // Giving Product Permission
            // addProduct(product, index) {
            //   product.has_access = !product.has_access;
            //   if (product.has_access) {
            //     this.userProducts.push({
            //       has_access: product.has_access,
            //       product: product._id,
            //       access_level: "2",
            //     });
            //   } else {
            //     for (var i = 0; i < this.userProducts.length; i++) {
            //       if (this.userProducts[i].product == product._id) {
            //         this.userProducts.splice(i, 1);
            //       }
            //     }
            //   }
            // },
            // var has_product = false;userProducts
            // this.userProducts.forEach(userProduct => {
            //   if (userProduct.product == product._id) {
            //     has_product = true;
            //     userProduct.has_access = product.has_access;
            //   }
            // });
            // if (!has_product) {
            //   this.userProducts.push({
            //     has_access: product.has_access,
            //     product: product._id,
            //     access_level: "2",
            //   });
            // }
            // this.productPermission(product._id,product.has_access)

            // productPermission(productId,has_access){
            //   for(var i=0;i<this.userProducts.length;i++){
            //     if(this.userProducts[i].product==productId){
            //         this.permission_dict['productuid'+index.toString()] = this.userProducts[i].access_level
            //     }
            //   }
            // },

            // Invite Employee to Company and Validations
            InviteEmployee() {
                this.$validator.validateAll("newEmployee").then(result => {
                    if (result && !this.EmailExists && this.EmailValid) {
                        let user_exists = false;
                        let data = {};
                        if (this.$route.params.id) {
                            user_exists = true;
                            data = {
                                // user_exists: user_exists,
                                first_name: this.newEmployee.first_name,
                                middle_name: this.newEmployee.middle_name,
                                last_name: this.newEmployee.last_name,
                                password: this.newEmployee.password,
                                primary_email: this.newEmployee.primary_email + "@" + this
                                    .selecteddomainname,
                                user_id: this.$route.params.id,
                                phone_number: this.newEmployee.primary_phone,
                                is_admin: this.is_admin,
                                is_superadmin: this.is_superadmin,
                                products: this.userProducts,
                                branch: this.branch.name._id,
                                department: this.department_name,
                                reporting_manager: {
                                    _id: this.newEmployee.reporting_manager._id,
                                    full_name: this.newEmployee.reporting_manager.full_name,
                                },
                            };
                        } else {
                            data = {
                                // user_exists: user_exists,
                                first_name: this.newEmployee.first_name,
                                middle_name: this.newEmployee.middle_name,
                                last_name: this.newEmployee.last_name,
                                password: this.newEmployee.password,
                                primary_email: this.newEmployee.primary_email + "@" + this
                                    .selecteddomainname,
                                user_id: this.$route.params.id,
                                phone_number: this.newEmployee.primary_phone,
                                gender: this.newEmployee.gender,
                                custom_gender: this.newEmployee.custom_gender,
                                is_admin: this.is_admin,
                                is_superadmin: this.is_superadmin,
                                products: this.userProducts,
                                branch: this.branch.name._id,
                                department: this.department_name,
                                reporting_manager: {
                                    _id: this.newEmployee.reporting_manager._id,
                                    full_name: this.newEmployee.reporting_manager.full_name,
                                },
                            };
                        }
                        // data.email_id = this.newEmployee.email_id.trim() + "@" + this.selecteddomainname.trim();
                        if (data.reporting_manager._id == "") {
                            delete data["reporting_manager"];
                        }
                        this.$http.post("/employees/add_user_to_company", data)
                            .then(res => {
                                if (res.data.status_id == 1) {
                                    this.$swal({
                                        title: "Employee Added",
                                        text: "Employee Invited Successfully",
                                        type: "success",
                                        confirmButtonText: "OK",
                                        confirmButtonColor: "#005dae",
                                    });
                                    this.$router.go(-1);
                                } else {
                                    this.$swal({
                                        title: "Error",
                                        text: "Inviting Employee Failed. Please Try Again",
                                        type: "error",
                                        confirmButtonText: "OK",
                                        confirmButtonColor: "#005dae",
                                    });
                                }
                            });
                    } else if (!result) {
                        this.$swal({
                            title: "Error!",
                            text: "Please Fill All Mandatory Fields",
                            type: "error",
                            confirmButtonText: "OK",
                            confirmButtonColor: "#005dae",
                        });
                    } else if (this.EmailExists) {
                        this.$swal({
                            title: "Error!",
                            text: "Business Email Already Exists",
                            type: "error",
                            confirmButtonText: "OK",
                            confirmButtonColor: "#005dae",
                        });
                    } else if (!this.EmailValid) {
                        this.$swal({
                            title: "Error!",
                            text: "Business Email is Not Valid",
                            type: "error",
                            confirmButtonText: "OK",
                            confirmButtonColor: "#005dae",
                        });
                    }
                });
            },

            // Checking Primary(Personal) Email Exists
            checkPrimaryEmail() {
                this.$http
                    .post("/check_email_validity", {
                        email_id: this.newEmployee.primary_email,
                        email_type: "personal",
                    })
                    .then(response => {
                        if (response.data.status_id == 1) {
                            this.primaryEmailExists = response.data.exists;
                            // this.primaryEmailValid = response.data.valid;
                        } else this.primaryEmailValid = response.data.valid;
                    })
                    .catch(error => {});
            },

            // Checking Email Name Exits and Domain Validation and Sending Concatenated Data
            checkEmail() {
                if (this.getDomain.length) {
                    this.getDomain = [];
                }
                if (this.newEmployee.primary_email && this.selecteddomainname) {
                    this.$http
                        .post("/check_email_validity", {
                            email_id: this.newEmployee.primary_email + "@" + this.selecteddomainname,
                            email_type: "business",
                        }).then(response => {
                            this.EmailExists = response.data.exists;
                            // this.EmailValid = response.data.valid;
                        }).catch(error => {});
                }
            },

            // Getting All Products not Purcahsed
            getProducts() {
                if (this.account) {
                    this.$http
                        .get("/company/get_products_purchased_not_purchased")
                        .then(res => {
                            if (res.data.status_id == 1) {
                                this.products = res.data.response.purchased_products;
                                this.products.forEach(product => {
                                    product.has_access = false;
                                    product.access_level = "2";
                                });
                            }
                        });
                }
            },
            showDepartments() {
                this.department_name = "";
                this.isDept = true
                let index = this.branch_name.findIndex(
                    x => x.name === this.branch.name.name
                );
                // this.branch = this.branch_name[index]
                this.branch_departments = this.branch_name[index].departments;
                this.isDept = false
            },
            checkPublicDomain() {
                this.$http.get("/company/get_public_domain").then(res => {
                    if (res.data.status_id == 1) {
                        if ("allow_public_domain" in res.data.response) {
                            if (res.data.response.allow_public_domain) {
                                this.allow_public_domain = true;
                            }
                        }
                    }
                });
            },
            customSelected() {
                if (!this.customGender) {
                    this.newEmployee.gender = "";
                    this.customGender = true;
                }
            },
            customDeselected() {
                if (this.customGender) {
                    this.customGender = false;
                    this.newEmployee.gender = "Male";
                }
            },
            goBackToEmployees() {
                localStorage.setItem("backToEmployees", true);
                this.$router.push("/companyprofile/" + this.account);
            },
            async getReportingManager() {
                this.isReport = false
                let params = {
                    search_key: "",
                    skip: 0,
                    limit: 10,
                    company_id: this.selectedCompany._id,
                    active_status: "active",
                };
                let res = await this.$http.post("/employees/get_employees", params);
                if (res.data.status_id == 1) {
                    this.reporting_managers = res.data.response;
                    this.isReport = true
                }
            }
        },
    };
</script>
<style>
    .previewElements {
        margin-bottom: 11px;
        margin-top: 3px;
    }

    .previewElementsContacts {
        margin-bottom: 2px;
        margin-top: 3px;
    }

    .select:focus {
        border-bottom: solid 1px #00448b !important;
        transition: 0.2s ease all;
        -moz-transition: 0.2s ease all;
        -webkit-transition: 0.2s ease all;
    }

    .selectMap {
        width: 22px;
        height: 22px;
        margin-left: 5px;
        object-fit: contain;
    }

    .socialMedia.dropdown-toggle::after {
        margin-left: 21px;
    }

    .companySelect.v-select input[type="search"] {
        padding: 0 5px !important;
    }

    @-moz-document url-prefix() {
        .inputMedia {
            padding-right: 26px !important;
        }
    }

    .input-group.digi-input-group-dropdown {
        border: 1px solid transparent !important;
    }

    .input-group.digi-input-group-dropdown>.form-control {
        position: relative !important;
        -webkit-box-flex: 1 !important;
        -webkit-flex: 1 1 auto !important;
        -ms-flex: 1 1 auto !important;
        flex: 1 1 auto !important;
        width: 1% !important;
        margin-bottom: 0 !important;
        height: 34px !important;
        padding: 6px 12px 6px 2px !important;
        color: #303031;
        border-bottom: 1px solid #a9aaad !important;
    }

    .input-group.digi-input-group-dropdown .input-group-addon {
        padding-left: 0rem !important;
        padding-right: 0.2rem !important;
        border-bottom: 1px solid #a9aaad !important;
        padding-top: 2px;
        cursor: pointer;
        margin-left: 0px !important;
    }

    .input-group.digi-input-group-dropdown .input-group-append {
        padding-left: 0rem !important;
        padding-right: 0.2rem !important;
        border-bottom: 1px solid #a9aaad !important;
        padding-top: 2px;
        cursor: pointer;
        margin-left: 0px !important;
        height: 34px !important;
    }

    .input-group.digi-input-group-dropdown .input-group-append button.btn.btn-link {
        text-transform: none !important;
        text-decoration: none !important;
        color: #303031 !important;
        height: 34px !important;
        line-height: 34px !important;
        font-weight: 500 !important;
    }

    .overflow-modal.v--modal-overlay .v--modal-box {
        overflow: visible !important;
    }

    .overflow-modal.v--modal-overlay .v--modal-box .v-modal-content {
        border-radius: 15px;
    }

    .overflow-modal.v--modal-overlay .v--modal-box .v-modal-content .v-modal-body {
        overflow: visible;
    }

    .heading-title {
        font-size: 14px;
        font-weight: 600;
        border-top-left-radius: 15px;
        border-top-right-radius: 15px;
        background-color: #00448b;
        padding: 20px 24px;
        color: #fff;
        text-transform: uppercase;
        line-height: normal;
        letter-spacing: 0.6px;
        text-align: center;
    }

    #table-app-access thead>tr {
        background: #fff;
    }

    #table-app-access thead tr th {
        text-transform: uppercase;
        color: #00448b;
    }

    #table-app-access thead tr th {
        padding: 16px 10px !important;
        border-bottom: 1px solid #e9ecef;
        vertical-align: middle;
    }

    #table-app-access tbody tr td,
    #table-app-access thead tr th {
        font-size: 13px;
        font-weight: 700;
        line-height: normal;
        letter-spacing: 0.5px;
        padding-left: 24px;
    }

    .table-striped tbody tr:nth-of-type(odd) {
        background-color: #f5f6f9;
    }

    .table-striped tbody tr:nth-of-type(2n) {
        background-color: #fff;
    }

    #table-app-access tbody tr td {
        color: #4e5764;
    }

    #table-app-access tbody tr td {
        padding: 11px 10px !important;
        vertical-align: middle;
    }

    input[type="radio"].radiobutton {
        position: absolute;
        visibility: hidden;
        display: none;
        box-sizing: border-box;
        padding: 0;
    }

    label.label-permissions {
        font-size: 12px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        letter-spacing: normal;
        text-align: center;
        color: #00448b !important;
        cursor: pointer;
        font-weight: bold;
        padding: 6px 14px;
        margin-bottom: 0px;
        margin-right: 0px;
        border: 1px solid #5ca7ec;
        border-radius: 4px;
    }

    input[type="radio"].radiobutton:checked+label.label-permissions {
        color: #fff !important;
        background: #00448b !important;
    }

    .radiooptions .form-check-inline.user-perm .form-check-label {
        width: 120px;
    }

    .radiooptions .form-check-inline.gender-radio .form-check-label {
        width: 66px;
    }

    .switch {
        font-size: 1rem;
        position: relative;
    }

    .switch input {
        position: absolute;
        height: 1px;
        width: 1px;
        background: 0 0;
        border: 0;
        clip: rect(0 0 0 0);
        clip-path: inset(50%);
        overflow: hidden;
        padding: 0;
    }

    .switch input+label {
        position: relative;
        min-width: calc(calc(2.375rem * 0.8) * 2);
        border-radius: calc(2.375rem * 0.8);
        height: calc(2.375rem * 0.8);
        line-height: calc(2.375rem * 0.8);
        display: inline-block;
        cursor: pointer;
        outline: 0;
        user-select: none;
        vertical-align: middle;
        text-indent: calc(calc(calc(2.375rem * 0.8) * 2) + 0.5rem);
    }

    .switch input+label::after,
    .switch input+label::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: calc(calc(2.375rem * 0.8) * 2);
        bottom: 0;
        display: block;
    }

    .switch input+label::before {
        right: 0;
        background-color: #cdd2da;
        border-radius: calc(2.375rem * 0.8);
        transition: 0.2s all;
    }

    .switch input+label::after {
        top: 2px;
        left: 2px;
        width: calc(calc(2.375rem * 0.8) - calc(2px * 2));
        height: calc(calc(2.375rem * 0.8) - calc(2px * 2));
        border-radius: 50%;
        background-color: #fff;
        transition: 0.2s all;
    }

    .switch input:checked+label::before {
        background-color: #00448b;
    }

    .switch input:checked+label::after {
        margin-left: calc(2.375rem * 0.8);
    }

    .switch input:focus+label::before {
        outline: 0;
        box-shadow: 0 0 0 0.2rem rgba(0, 136, 221, 0.25);
    }

    .switch input:disabled+label {
        color: #868e96;
        cursor: not-allowed;
    }

    .switch input:disabled+label::before {
        background-color: #e9ecef;
    }

    .switch.switch-sm {
        font-size: 0.875rem;
    }

    .switch.switch-sm input+label {
        min-width: calc(calc(1.9375rem * 0.8) * 2);
        height: calc(1.9375rem * 0.8);
        line-height: calc(1.9375rem * 0.8);
        text-indent: calc(calc(calc(1.9375rem * 0.8) * 2) + 0.5rem);
    }

    .switch.switch-sm input+label::before {
        width: calc(calc(1.9375rem * 0.8) * 2);
    }

    .switch.switch-sm input+label::after {
        width: calc(calc(1.9375rem * 0.8) - calc(2px * 2));
        height: calc(calc(1.9375rem * 0.8) - calc(2px * 2));
    }

    .switch.switch-sm input:checked+label::after {
        margin-left: calc(1.9375rem * 0.8);
    }

    .switch.switch-lg {
        font-size: 1.25rem;
    }

    .switch.switch-lg input+label {
        min-width: calc(calc(3rem * 0.8) * 2);
        height: calc(3rem * 0.8);
        line-height: calc(3rem * 0.8);
        text-indent: calc(calc(calc(3rem * 0.8) * 2) + 0.5rem);
    }

    .switch.switch-lg input+label::before {
        width: calc(calc(3rem * 0.8) * 2);
    }

    .switch.switch-lg input+label::after {
        width: calc(calc(3rem * 0.8) - calc(2px * 2));
        height: calc(calc(3rem * 0.8) - calc(2px * 2));
    }

    .switch.switch-lg input:checked+label::after {
        margin-left: calc(3rem * 0.8);
    }

    .switch+.switch {
        margin-left: 1rem;
    }

    .page-content-header-text {
        font-size: 15px;
        font-weight: bold;
        line-height: 1.2;
        letter-spacing: 0.64px;
        text-align: center;
        color: #4e5764;
        margin: 20px 20px 30px;
        display: block;
        position: relative;
    }

    .multiselect.diginew-multiselect.comanyTimeSelect .multiselect__tags {
        background: transparent !important;
    }

    .multiselect.diginew-multiselect.comanyTimeSelect .multiselect__single {
        background: transparent !important;
    }

    .multiselect.diginew-multiselect.comanyTimeSelect .multiselect__input {
        background: transparent !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/AddEmployee.vue